import React from "react";
import {PushpinFilled} from "@ant-design/icons";
import "./index.scss"

export function PinnedColumnsInfo() {
    return (
        <div className="table-note">
            <PushpinFilled
                style={{
                    fontSize: "18px",
                    margin: "5px",
                    color: "#000000"
                }}
                aria-label={"pin"}
            />
            <span>
                Columns are pinned by default and cannot be moved.
                Please use the horizontal scroll to scroll through the columns
            </span>
        </div>
    )
}
